














































































































































































import Card from "@/components/UI/Card.vue";
import {Component, Prop, Watch, Mixins} from "vue-property-decorator";
import Toast from "@/mixins/toast";
import Http from '@/mixins/http';
import moment, {Moment} from "moment";
import {
    CompetitorsPriceFilter,
    ICompetitorPricesFilterOptions,
    SortingField,
    RegularCompetitorsPricesView,

} from "@/interfaces/server-data";
import {CompetitorsPriceRow, ICompetitorsTableFilterValues} from "@/interfaces/competitors-price-row";
import {SelectBox} from "@/interfaces/global-data";
import LocalData from "@/mixins/local-data";

interface FilterItem {
	id: number;
	text: string;
	value: number;
	isSelected: boolean;
}

interface CombinedFilters {
	groups: FilterItem[];
	categories: FilterItem[];
	subcategories: FilterItem[];
	storeFormat: FilterItem[];
	storeRegion: FilterItem[];
	storeCluster: FilterItem[];
}

interface TheMarket {
	id: number;
	tradingName: string;
	isDefault: boolean;
	editable: boolean;
}

@Component({
	components: {
		Card,
	},
})
export default class CompetitorsPrice extends Mixins(Toast, Http) {
	@Prop({required: true}) theFilters!: CombinedFilters;
	@Prop({required: true}) theMarket!: TheMarket;
	filters: Record<string, any[]> = {};
	startDate: Moment | null = moment().subtract(28, "days");
	endDate: Moment | null = moment();
	isTableLoading: boolean = false;
    filterDropdownsRange: any = {
        from: {},
        to: {},
    };
    filterAllCheckboxCheckedState: any = {};
    compPricesTablePagination: any = {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
    }
    competitorsTableFilterOptions: ICompetitorPricesFilterOptions  = {
        optionCompetitorPrices: [],
        optionCompetitorPriorities: [],
        optionCompetitorsCodes: [],
        optionCompetitorsNames: [],
        optionDeltas: [],
        optionInternalCodes: [],
        optionKeyCharacteristicsOfTheProductIsOne: [],
        optionKeyCharacteristicsOfTheProductIsTwo: [],
        optionLastPrices: [],
        optionPriceDates: [],
        optionPromoPrices: [],
        optionRegions: [],
        optionSkuNames: [],
        optionStoreFormats: [],
        kviOptions: [],
        ctmOptions: [],
    };
    fullOptionsData: {
        storeFormats: any[],
        storeRegions: any[],
    } = {
        storeFormats: [],
        storeRegions: [],
    }
    competitorsTableFilterValues: ICompetitorsTableFilterValues = {
        kviValue: -1,
        ctmValue: 'all',
    };
    sortingField: SortingField | null = null;
    needFetchCompetitorCodes: boolean = false;
    ignoreOneTopFiltersChange: boolean = false;
    compPricesTableData: any[] = [];
	compPricesTableColumns: any[] = [
		{
			dataIndex: "internalCode",
			title: this.$t('shared.table.internalCode') as string,
            filterOptionsKey: 'optionInternalCodes',
            filterModelKey: 'internalCodes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			sorter: true,
			ellipsis: true,
			width: 170,
		},
		{
			dataIndex: "storeFormat",
			title: this.$t('shared.table.format') as string,
            filterOptionsKey: 'optionStoreFormats',
            filterModelKey: 'storeFormats',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			sorter: true,
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "storeRegion",
			sorter: true,
			title: this.$t('shared.table.region') as string,
            filterOptionsKey: 'optionRegions',
            filterModelKey: 'storeRegionValues',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "skuName",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.skuName') as string,
            filterOptionsKey: 'optionSkuNames',
            filterModelKey: 'skuNames',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 170,
		},
		{
			dataIndex: "competitorName",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.competitor') as string,
            filterOptionsKey: 'optionCompetitorsNames',
            filterModelKey: 'competitors',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
        {
            dataIndex: 'competitorCode',
            sorter: true,
            title: this.$t('shared.table.competitorCode') as string,
            filterOptionsKey: 'optionCompetitorsCodes',
            filterModelKey: 'competitorCodes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 170
        },
		{
			dataIndex: "competitorPriority",
			sorter: true,
			title: this.$t('shared.table.competitorPriority') as string,
            filterOptionsKey: 'optionCompetitorPriorities',
            filterModelKey: 'competitorPriorities',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 230,
		},
		{
			dataIndex: "lastPrice",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.ourPrice') as string,
            filterOptionsKey: 'optionLastPrices',
            filterModelKey: 'lastPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "promoPrice",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.promoCompetitorPrice') as string,
            filterOptionsKey: 'optionPromoPrices',
            filterModelKey: 'promoPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 250,
		},
		{
			dataIndex: "competitorPrice",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.competitorPrice') as string,
			// customRender: this.numberFormatter,
            filterOptionsKey: 'optionCompetitorPrices',
            filterModelKey: 'competitorPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 200,
		},
		{
			dataIndex: "delta",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.deviation') as string,
			customRender: (value: number) => `${value.toFixed(2)}%`,
            filterOptionsKey: 'optionDeltas',
            filterModelKey: 'deltas',
            showRange: true,
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "kvi",
			sorter: true,
			title: "KVI",
			customRender: (value: number) => (value ? this.$t('shared.boolFilter.yes') as string : this.$t('shared.boolFilter.no') as string),
            filterOptionsKey: 'kviOptions',
            filterModelKey: 'kviValue',
            scopedSlots: {filterDropdown: 'filterRadioButtons', filterIcon: "radioButtonsWithAllFilterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "ctm",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.ctm') as string,
            filterOptionsKey: 'ctmOptions',
            filterModelKey: 'ctmValue',
            scopedSlots: {filterDropdown: 'filterRadioButtons', filterIcon: "radioButtonsWithAllFilterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
            dataIndex: 'keyCharacteristicOfTheProductIsOne',
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.kht1') as string,
            filterOptionsKey: 'optionKeyCharacteristicsOfTheProductIsOne',
            filterModelKey: 'keyCharacteristicsOfTheProductIsOnes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
            dataIndex: 'keyCharacteristicOfTheProductIsTwo',
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.kht2') as string,
            filterOptionsKey: 'optionKeyCharacteristicsOfTheProductIsTwo',
            filterModelKey: 'keyCharacteristicsOfTheProductIsTwos',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 150,
		},
		{
			dataIndex: "priceDate",
			sorter: true,
			title: this.$t('priceMonitoring.competitorsPrice.monitoringDate') as string,
			customRender: (value: any) => moment(new Date(+value)).format("DD.MM.YYYY"),
            filterOptionsKey: 'optionPriceDates',
            filterModelKey: 'priceDates',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
			ellipsis: true,
			width: 200,
		},
	];

    private get theFiltersForComparing() {
        return JSON.parse(JSON.stringify(this.theFilters));
    }

    @Watch("theFiltersForComparing", { deep: true, immediate: true })
    onTheFiltersChanged(newValue: CombinedFilters, oldValue: CombinedFilters) {
        this.fetchTableData(1);

        const newFormatIds = newValue.storeFormat.filter(el => el.isSelected).map(item => item.id);
        const newRegionIds = newValue.storeRegion.filter(el => el.isSelected).map(item => item.id);

        if (!LocalData.compareTwoArrays(newFormatIds, oldValue.storeFormat.filter(el => el.isSelected).map(item => item.id))) {
            if (this.ignoreOneTopFiltersChange) {
                this.ignoreOneTopFiltersChange = false;
                return;
            }

            this.competitorsTableFilterValues.storeFormats = newFormatIds;
            this.competitorsTableFilterValues.storeRegionValues = newRegionIds;
        } else if (!LocalData.compareTwoArrays(newRegionIds, oldValue.storeRegion.filter(el => el.isSelected).map(item => item.id))) {
            if (this.ignoreOneTopFiltersChange) {
                this.ignoreOneTopFiltersChange = false;
                return;
            }

            this.competitorsTableFilterValues.storeRegionValues = newRegionIds;
        }
    }

	get daysDifference(): number | null {
		if (this.startDate && this.endDate) {
			return this.endDate.diff(this.startDate, "days");
		}
		return null;
	}

	handleTableChange(pagination: any, filters: Record<string, any[]>, sorter: any) {
        this.compPricesTablePagination.current = pagination.current;
        this.compPricesTablePagination.pageSize = pagination.pageSize;

        if (sorter.field && sorter.order) {
            this.sortingField = {
                fieldName: sorter.field === 'priceDate' ? 'competitorDate' : sorter.field,
                sortValue: sorter.order === 'ascend' ? 0 : 1,
            }
        } else if (this.sortingField) {
            this.sortingField = null;
        }

        this.fetchCompPricesTableData();
	}

    toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
        return {
            ...competitor,
            competitorDate: new Date(competitor.priceDate),
            ctm: competitor.ctm == null ? this.$t('shared.boolFilter.no') as string : competitor.ctm
        }
    }

    async fetchFullFormatAndRegionOptions() {
        try {
            const response = await Promise.all([
                this.$http.post("/api/task/info", {
                    groups: [],
                    categories: [],
                    subcategories: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    tradingId: this.theMarket.id,
                    type: 'format',
                }),
                this.$http.post("/api/task/info", {
                    groups: [],
                    categories: [],
                    subcategories: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    tradingId: this.theMarket.id,
                    type: 'region',
                }),
            ]);

            this.fullOptionsData = {
                storeFormats: response[0].data.storeFormat,
                storeRegions: response[1].data.storeRegion,
            }

            return Promise.resolve();
        } catch (error) {
            console.error("Error when load full options:", error);

            return Promise.reject();
        }
    }

	async fetchTableData(currentPage?: number) {
		this.fetchCompPricesTableData(currentPage);
		this.fetchTableFilterOptions();
	}

    fetchCompPricesTableData(currentPage?: number) {
        if (currentPage) {
            this.compPricesTablePagination.current = currentPage;
        }

        const competitorFilter = this.getCompetitorsFilter();

        this.isTableLoading = true;

        this.httpLoadCompetitorsPrice(competitorFilter, this.compPricesTablePagination.pageSize, this.compPricesTablePagination.pageSize * (this.compPricesTablePagination.current - 1))
            .then((response) => {
                this.compPricesTableData = response.data.content.map(this.toRow);

                this.compPricesTablePagination.total = response.data.totalElements;
            })
            .catch((e) => {
                console.error(e)
                this.showError(this.$t('priceMonitoring.competitorsPrice.errorLoadPrices') as string);
            }).finally(() => {
            setTimeout(() => {
                this.isTableLoading = false;
            }, 100);
        });

        if (this.needFetchCompetitorCodes) {
            this.httpLoadCompetitorsTableFilterOptions(this.getCompetitorsFilter(true))
                .then((response) => {
                    this.competitorsTableFilterOptions = {
                        ...this.competitorsTableFilterOptions,
                        optionCompetitorsCodes: response.data.optionCompetitorsCodes,
                    };
                })
                .catch((e) => {
                    console.error(e)
                    this.showError(this.$t('priceMonitoring.competitorsPrice.errorLoadFilterOptions') as string);
                }).finally(() => {
                    this.needFetchCompetitorCodes = false;
                })
        }
    }

    fetchTableFilterOptions() {
        if (this.theMarket.id === -1) {
            return;
        }

        const competitorFilter = this.getCompetitorsFilter(true);

        this.httpLoadCompetitorsTableFilterOptions(competitorFilter)
            .then((response) => {
                this.competitorsTableFilterOptions = {
                    ...response.data,
                    kviOptions: [
                        {value: -1, label: this.$t('priceMonitoring.competitorsPrice.allKvi') as string},
                        {value: 1, label: this.$t('priceMonitoring.competitorsPrice.kvi') as string},
                        {value: 0, label: this.$t('priceMonitoring.competitorsPrice.notKvi') as string},
                    ],
                    ctmOptions: [
                        {value: 'all', label: this.$t('priceMonitoring.competitorsPrice.allCtm') as string},
                        {value: '1', label: this.$t('priceMonitoring.competitorsPrice.ctmLabel') as string},
                        {value: '0', label: this.$t('priceMonitoring.competitorsPrice.notCtm') as string},
                    ],
                };
            })
            .catch((e) => {
                console.error(e)
                this.showError(this.$t('priceMonitoring.competitorsPrice.errorLoadFilterOptions') as string);
            })
    }

    private getCompetitorsFilter(isFilterForFetchOptions: boolean = false): CompetitorsPriceFilter {
        const storeFormatsFromTopFilters = this.theFilters.storeFormat.filter((item) => item.isSelected).map((item) => item.id);
        const storeRegionsFromTopFilters = this.theFilters.storeRegion.filter((item) => item.isSelected).map((item) => item.id);

        return {
            discountPrise: false,
            category: null,
            categories: this.theFilters.categories.filter((item) => item.isSelected).map((item) => item.id),
            storeCluster: null,
            storeClusters: this.theFilters.storeCluster.filter((item) => item.isSelected).map((item) => item.id),
            seasonValues: [],
            buyerSegments: [],
            storeRegionValues: !isFilterForFetchOptions ? (storeRegionsFromTopFilters.length ? storeRegionsFromTopFilters : this.competitorsTableFilterValues.storeRegionValues || []) : [],
            groupOfProduct: null,
            groupsOfProduct: this.theFilters.groups.filter((item) => item.isSelected).map((item) => item.id),
            storeFormat: null,
            storeFormats: !isFilterForFetchOptions ? (storeFormatsFromTopFilters.length ? storeFormatsFromTopFilters : this.competitorsTableFilterValues.storeFormats) : [],
            tradingId: this.theMarket.id,
            calculationDepth: 4,
            calculationDay: 28,
            skuFilter: "",
            subcategories: this.theFilters.subcategories.filter((item) => item.isSelected).map((item) => item.id),
            productSegments: [],
            competitorsPricePeriod: this.daysDifference as number,
            promo: false,
            sortBySKU: -1,
            kvi: this.competitorsTableFilterValues['kviValue'],
            ctm: this.competitorsTableFilterValues['ctmValue']  === 'all' ? null : this.competitorsTableFilterValues['ctmValue'],
            sortingField: this.sortingField,
            isKviCartCompetitorsGrid: false,
            skuNames: this.competitorsTableFilterValues['skuNames'],
            competitors: this.competitorsTableFilterValues['competitors'],
            competitorCodes: this.competitorsTableFilterValues['competitorCodes'],
            competitorPriorities: this.competitorsTableFilterValues['competitorPriorities'],
            lastPrices: this.competitorsTableFilterValues['lastPrices'],
            promoPrices: this.competitorsTableFilterValues['promoPrices'],
            competitorPrices: this.competitorsTableFilterValues['competitorPrices'],
            keyCharacteristicsOfTheProductIsOnes: this.competitorsTableFilterValues['keyCharacteristicsOfTheProductIsOnes'],
            keyCharacteristicsOfTheProductIsTwos: this.competitorsTableFilterValues['keyCharacteristicsOfTheProductIsTwos'],
            priceDates: this.competitorsTableFilterValues['priceDates'],
            deltas: this.competitorsTableFilterValues['deltas'],
            internalCodes: this.competitorsTableFilterValues['internalCodes'],
        };
    }

    handleFilterAllCheckboxChanged(value: boolean, filterModel: keyof ICompetitorsTableFilterValues, filterOptionsKey: keyof ICompetitorPricesFilterOptions, useRange: boolean = false) {
        this.filterAllCheckboxCheckedState[filterModel] = value;

        if (value) {
            this.competitorsTableFilterValues[filterModel] = [
                ...new Set([
                    ...(this.competitorsTableFilterValues[filterModel] as number[] || []),
                    ...(this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<SelectBox<number>>).map((option: SelectBox<number>) => option.value),
                ])
            ];
        } else {
            const optionValuesToDeselect = (this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<SelectBox<number>>).map((option: SelectBox<number>) => option.value);

            this.competitorsTableFilterValues[filterModel] = (this.competitorsTableFilterValues[filterModel] as number[] || []).filter((value: number) => !optionValuesToDeselect.includes(value));
        }
    }

    getFilterOptions(filterModel: string, filterOptionsKey: keyof ICompetitorPricesFilterOptions, useRange: boolean = false) {
        if (useRange) {
            return (this.getCheckboxGroupOptions(filterOptionsKey) as Array<SelectBox<number>>).filter((option: SelectBox<number>) => {
                if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return option.value >= this.filterDropdownsRange.from[filterModel];
                } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return option.value <= this.filterDropdownsRange.to[filterModel];
                } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
                } else {
                    return true;
                }
            })
        } else {
            return this.getCheckboxGroupOptions(filterOptionsKey);
        }
    }

    getCheckboxGroupOptions(filterOptionsKey: keyof ICompetitorPricesFilterOptions): Array<SelectBox<number | string>> {
        return (this.competitorsTableFilterOptions[filterOptionsKey] as (string | number)[]).map((el: string | number) => {
            if (filterOptionsKey === 'optionStoreFormats' || filterOptionsKey === 'optionRegions') {
                const optionData = this.fullOptionsData[filterOptionsKey === 'optionStoreFormats' ? 'storeFormats' : 'storeRegions'].find(option => option.name === el);

                if (optionData) {
                    return {
                        label: optionData.name,
                        value: optionData.id,
                    }
                } else {
                    return {
                        label: '',
                        value: 0,
                    }
                }
            } else if (filterOptionsKey === 'optionPriceDates') {
                return {
                    label: new Date(el).toLocaleDateString(),
                    value: el,
                }
            } else {
                return {
                    label: String(el),
                    value: el,
                }
            }
        }).filter((option: SelectBox<number | string>) => !!option.value);
    }

    handleModelChanged(filterModelKey: string) {
        if (filterModelKey === 'competitors') {
            this.needFetchCompetitorCodes = true;
        } else if (filterModelKey === 'storeFormats' || filterModelKey === 'storeRegionValues') {
            if (this.theFilters.storeFormat.some(el => el.isSelected) || this.theFilters.storeRegion.some(el => el.isSelected) || this.theFilters.storeCluster.some(el => el.isSelected)) {
                this.ignoreOneTopFiltersChange = true;

                this.$emit('reset-shop-levels-filters');
            }
        }
    }

    resetRadioButtons(filterModelKey: keyof ICompetitorsTableFilterValues) {
        if (filterModelKey === 'kviValue') {
            this.competitorsTableFilterValues.kviValue = -1;
        } else if (filterModelKey === 'ctmValue') {
            this.competitorsTableFilterValues.ctmValue = 'all';
        } else {
            this.competitorsTableFilterValues[filterModelKey] = [];
        }
    }

	mounted() {
        if (this.theFilters.storeFormat.some(el => el.isSelected)) {
            this.competitorsTableFilterValues.storeFormats = this.theFilters.storeFormat.filter(el => el.isSelected).map(item => item.id);
        }

        if (this.theFilters.storeRegion.some(el => el.isSelected)) {
            this.competitorsTableFilterValues.storeRegionValues = this.theFilters.storeRegion.filter(el => el.isSelected).map(item => item.id);
        }

        this.fetchFullFormatAndRegionOptions().then(() => {
            this.fetchTableData();
        })
	}
}
